export default "/_next/static/images/section-6-8f7222bcf712f5759b456e724d9f9c30.png";